<template>
  <main>
    <div class="container">
      <div class="page_content"
           v-if="htmlContent"
           v-html="htmlContent" />
      <template v-for="decor in data.decors"
                :key="decor.id">
        <h3>{{ decor.groupName }}</h3>
        <br>
        <SwiperGallery :files="decor.images"
                       :swiperOptions="swiperOptions" />
      </template>
    </div>
  </main>
</template>

<script setup lang="ts">
import { SwiperGallery } from '@/components';
import type { SwiperOptions } from 'swiper';
import type { IDecorsPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IDecorsPage>('page-decor', {
  populate: 'deep',
});

const data = response.data as unknown as IDecorsPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;

const swiperOptions: SwiperOptions = {
  navigation: true,
  pagination: true,
  spaceBetween: 10,
};
</script>
